import MediaNotAvailable from '@components/media_not_available';
import { Img } from '@xo-union/tk-component-picture';
import React from 'react';
import type { Raw } from 'types/vendor';
import { getVendorImage } from '../../../utils/transformNetworkData';
import Styles from './ThreeVendorImageGrid.styles.scss';

interface ThreeVendorImageGridProps {
	vendors: Raw[];
}

export const ThreeVendorImageGrid: React.FC<ThreeVendorImageGridProps> = ({
	vendors,
}) => {
	const vendorsWithImages = vendors
		.map((vendor) => ({
			vendor,
			image: getVendorImage(vendor),
		}))
		.filter((item) => item.image !== null)
		.slice(0, 3);

	if (vendorsWithImages.length === 0) {
		return (
			<div
				className={Styles.placeholderWrapper}
				data-testid="celebration-photo-grid-placeholder"
			>
				<MediaNotAvailable />
			</div>
		);
	}

	return (
		<div
			className={Styles.threeVendorsLayout}
			data-testid="celebration-photo-grid-layout3"
		>
			<div
				className={Styles.mainImage}
				data-testid="celebration-photo-grid-main-image"
			>
				{vendorsWithImages[0] && (
					<Img
						src={vendorsWithImages[0].image as string}
						alt={vendorsWithImages[0].vendor.name}
						className={Styles.image}
						smartCrop
						data-testid="celebration-photo-grid-image-0"
					/>
				)}
			</div>
			<div
				className={Styles.sideImages}
				data-testid="celebration-photo-grid-side-images"
			>
				{vendorsWithImages[1] && (
					<div
						className={Styles.sideImageTop}
						data-testid="celebration-photo-grid-side-image-top"
					>
						<Img
							src={vendorsWithImages[1].image as string}
							alt={vendorsWithImages[1].vendor.name}
							className={Styles.image}
							smartCrop
							data-testid="celebration-photo-grid-image-1"
						/>
					</div>
				)}
				{vendorsWithImages[2] && (
					<div
						className={Styles.sideImageBottom}
						data-testid="celebration-photo-grid-side-image-bottom"
					>
						<Img
							src={vendorsWithImages[2].image as string}
							alt={vendorsWithImages[2].vendor.name}
							className={Styles.image}
							smartCrop
							data-testid="celebration-photo-grid-image-2"
						/>
					</div>
				)}
			</div>
		</div>
	);
};
